import { ContentBlockFragment } from '@graphqlTypes/sitecore';
import { makeAutoObservable } from 'mobx';
import { AppBaseStore } from './app-base-store';
import { SettingStore } from './setting-store';

export class VideoPopupStore {
    private videoUrl = '';
    enabledPopupVideo = false;
    private videoPoster = '';
    private contentBlockData = {};

    constructor(private baseStore: AppBaseStore, private settingStore: SettingStore) {
        makeAutoObservable(this, undefined, { deep: false });
    }

    get isLoading() {
        return this.baseStore.isLoading || this.settingStore.isLoading;
    }

    get getVideoUrl() {
        return this.videoUrl;
    }

    get getVideoPoster() {
        return this.videoPoster;
    }

    get getContentBlockData() {
        return this.contentBlockData;
    }

    updateUrlValue(newValue: string) {
        this.videoUrl = newValue;
    }

    updatePosterValue(newValue: string) {
        this.videoPoster = newValue;
    }

    updateContentBlockData(newValue?: ContentBlockFragment) {
        this.contentBlockData = newValue || {};
    }
}
